import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Detect Google'ın stok / standart Android tarayıcısı (Chrome olmayan)
if (typeof navigator !== 'undefined' && typeof document !== 'undefined') {
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const hasVersionToken = /Version\/\d+\.\d+/i.test(ua);
  const isChrome = /Chrome\/\d+/i.test(ua);

  // Eski/stok Android browser: Android + Version/xx.x var, Chrome yok
  const isAndroidStockBrowser = isAndroid && hasVersionToken && !isChrome;

  if (isAndroidStockBrowser) {
    document.documentElement.classList.add('android-stock-browser');
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
